import Vue from 'vue'
import store from '@vue/store/index'
import filters from '@vue/common/filters'
import FinalReview from './final-review'

if (document.getElementById('checkout-final-review')) {
  Vue.use(filters);

  new Vue({
    el: '#checkout-final-review',
    render: createElement => createElement(FinalReview),
    store
  })
}

